// The list surface shared by the inline editors that save on selection (Salesperson, dropdown custom
// fields): a scrollable column of full-width option rows, the current one tinted, and a thin divider
// that sets the clearing option apart from the real ones.
import Styled from 'styled-components';

export const List = Styled.div`
	display: flex;
	flex-direction: column;
	width: 280px;
	max-height: 320px;
	overflow-y: auto;
	padding: 4px;
`;
export const Option = Styled.button<{selected: boolean}>`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	padding: 8px;
	border: none;
	border-radius: 4px;
	background: ${({selected}) => (selected ? '#eef0ff' : 'none')};
	cursor: pointer;
	text-align: left;
	&:hover {
		background: #eef0ff;
	}
`;
export const Divider = Styled.span`
	height: 1px;
	margin: 4px 0;
	background: #e4e4e7;
`;
